import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Fallback: store session token in localStorage as Authorization backup
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("session_token");
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});

export default api;
